import * as React from 'react';
import PropTypes from 'prop-types';

import { AnimateProps, AnimateDelay } from './Animate.types';

/** Animate Component */
const getDelayValue = (delay: AnimateDelay) => {
  switch (typeof delay) {
    case 'string':
      return delay;
    case 'number':
      return `${delay}ms`;
    default:
      return undefined;
  }
};

const Animate = React.forwardRef(
  (
    {
      dataHook,
      animateClasses,
      delay,
      onStart,
      onEnd,
      children,
      animateInlineStyle,
    }: AnimateProps = { children: undefined },
    ref: React.Ref<HTMLDivElement>,
  ) => (
    <div
      data-hook={dataHook}
      className={animateClasses}
      style={{
        animationDelay: getDelayValue(delay),
        ...animateInlineStyle,
      }}
      onAnimationStart={onStart}
      onAnimationEnd={onEnd}
      ref={ref}
    >
      {children && React.Children.only(children)}
    </div>
  ),
);

Animate.propTypes = {
  animateClasses: PropTypes.string,
  dataHook: PropTypes.string,
  // @ts-ignore
  children: PropTypes.node.isRequired,
  onStart: PropTypes.func,
  onEnd: PropTypes.func,
  delay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  animateInlineStyle: PropTypes.object,
};

Animate.displayName = 'Animate';
export default Animate;
